// extracted by mini-css-extract-plugin
export default {"team":"team_team__op7is","button_div":"team_button_div__GBpvB","button":"team_button__kd3bQ"};